import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import InvolvedPartiesIcon from '@/svg-icons/InvolvedParties';

function PartiesInvolvedSection({ partiesInvolved }) {
  let show = false;
  const renderedParties = Object.keys(partiesInvolved).flatMap((partie, idx) => {
    const value = partiesInvolved[partie];
    
    if (Array.isArray(value)) {
      return value.map((person, personIdx) => {
        if (!person.name) return null;
        show = true;
        return (
          <div key={`${partie}-${personIdx}`} className="w-1/2 mb-[1vw]" data-cy={`order-details-partie-person-name-${person.name}`}>
            <div className="font-bold">
              {partie === 'other' && person.title?.trim() ? (
                person.title.trim()
              ) : (
                <FormattedMessage
                  id={`PERSON.${partie.toUpperCase()}`}
                  defaultMessage={partie === 'other' ? 'Outro' : partie}
                />
              )}{' '}
              {personIdx + 1}
            </div>
            <div>{person.name}</div>
          </div>
        );
      });
    } else if (value?.name) {
      show = true;
      return (
        <div key={partie} className="w-1/2 mb-[1vw]" data-cy={`order-details-partie-person-name-${value.name}`}>
          <div className="font-bold">
            <FormattedMessage id={`PERSON.${partie.toUpperCase()}`} />
          </div>
          <div>{value.name}</div>
        </div>
      );
    }
    return null;
  }).filter(Boolean);

  if (!show) return null;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <InvolvedPartiesIcon viewBox="0 0 34.016 34.016" className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="parties" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]" data-cy="order-details-parties-involved">
        {renderedParties}
      </div>
    </div>
  );
}

PartiesInvolvedSection.propTypes = {
  partiesInvolved: PropTypes.object.isRequired,
};

export default PartiesInvolvedSection;
